<template>
  <v-flex xs12 md12 class="mt-2 mb-0 pb-0">
    <div class="mx-3 mt-5">
      <v-tabs
        class="rounded light-shadow"
        center-active
        show-arrows
        v-model="bidTab"
      >
        <v-tab :to="{ name: 'bids-list' }">
          {{ $t("viewBids.view_as_list") }}
        </v-tab>
        <v-tab :to="{ name: 'bids-desk' }">
          {{ $t("viewBids.view_as_desk") }}
        </v-tab>
      </v-tabs>
    </div>
    <v-layout column>
      <v-row class="mx-0 w-100">
        <v-col cols="12" sm="6" md="8">
          <h1 class="py-3 text-no-wrap">
            {{ $t("viewBids.title") }}

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="success"
                  class="ml-1 green-shadow"
                  x-small
                  fab
                  max-width="26"
                  max-height="26"
                  v-on="on"
                  :title="$t('common.add')"
                  :loading="!fetched"
                >
                  <v-icon x-small>$plus</v-icon>
                </v-btn>
              </template>
              <v-list offset-y>
                <v-list-item>
                  <v-list-item-title class="pointer" @click="createBid(null)">
                    {{ $t("viewBids.bid_for_new_customer") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title
                    class="pointer"
                    @click="customerFindForm = true"
                  >
                    {{ $t("viewBids.bid_for_exist_customer") }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </h1>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="4"
          class="d-flex w-100 justify-sm-end flex-grow-1"
        >
          <bid-stage-filter-select
            v-if="$route.name === 'bids-list'"
            :label="$t('viewBids.bid_status')"
            :bid-stages="bidStages"
            :loading="!fetched"
            @update="setStagesForSearch"
          ></bid-stage-filter-select>
          <!-- даты --->
          <v-card v-if="$route.name !== 'bids-list'" elevation="0">
            <v-card-text class="justify-center text-no-wrap">
              <div class="d-inline-block">
                <v-menu
                  v-model="isFromDatePickerVisible"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <h3 class="d-inline dashed">
                        {{ $moment(period.from).format("DD.MM.YYYY") }}
                      </h3>
                    </span>
                  </template>
                  <v-date-picker
                    :first-day-of-week="first_day_of_week"
                    v-model="period.from"
                    @input="isFromDatePickerVisible = false"
                    :locale="locale"
                  >
                  </v-date-picker>
                </v-menu>
                ~
                <v-menu
                  v-model="isToDatePickerVisible"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <h3 class="d-inline dashed">
                        {{ $moment(period.to).format("DD.MM.YYYY") }}
                      </h3>
                    </span>
                  </template>
                  <v-date-picker
                    :first-day-of-week="first_day_of_week"
                    v-model="period.to"
                    @input="isToDatePickerVisible = false"
                    :locale="locale"
                  >
                  </v-date-picker>
                </v-menu>
              </div>
              <v-icon small class="mx-2">fa-calendar-alt</v-icon>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="customerFindForm" scrollable max-width="500">
        <customerFindForm
          @select="
            (customer) => {
              createBid(customer);
              customerFindForm = false;
            }
          "
          :visible="customerFindForm"
        ></customerFindForm>
      </v-dialog>
      <bid-window
        :show="bidWin.isVisible"
        @hide="bidWin.isVisible = false"
        :customer="bidWin.customer"
        :bid="null"
      ></bid-window>
      <router-view></router-view>
    </v-layout>
  </v-flex>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import CustomerFindForm from "@/components/customer/CustomerFindForm";
import CommonMixin from "@/mixins/common";
import BidWindow from "@/components/bid/BidWindow";
import BidStageFilterSelect from "@/components/bid/BidStageFilterSelect";
export default {
  components: { BidStageFilterSelect, CustomerFindForm, BidWindow },
  data: () => ({
    bidTab: 0,
    customerFindForm: false,
    isFromDatePickerVisible: false,
    isToDatePickerVisible: false,
    bidWin: {
      isVisible: false,
      customer: null,
    },
  }),
  mixins: [CommonMixin],
  mounted() {},
  computed: {
    ...mapFields("bids", ["search", "period", "fetched", "stagesForSearch"]),
    ...mapFields("bid_stages", ["bidStages"]),
  },
  methods: {
    setStagesForSearch(stagesIds) {
      this.stagesForSearch = stagesIds.join();
      this.$store.dispatch("bids/getList");
    },
    createBid(customer) {
      if (customer) {
        this.bidWin.customer = customer;
      } else {
        this.bidWin.customer = null;
      }
      this.bidWin.isVisible = true;
    },
  },
  watch: {},
};
</script>
<style lang="scss"></style>
